/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-use-before-define */
import {DESKTOP_BREAKPOINT} from '@constant/system';
import useCommon from '@utils/hooks/common';
import {Button, Dropdown, Menu, notification, Spin, Tooltip} from 'antd';
import {COLOR_THEME, GAME_TABLE_MARGIN_PX, SUIT, getGameEventV3} from '@constant/game';
import {getPokerImage, showSystemError} from '@utils/index';
import diamondItemsApi from '@utils/api/diamondItems';
import {env} from 'next-runtime-env';
import {Router, useRouter} from 'next/router';
import {useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState} from 'react';

import styles from './styles';
import {useCurrencyId, useGameMode} from '@utils/hooks/gameSettings';
import React from 'react';
import {useDebugView} from '@utils/hooks/debug';
import {autorun, toJS} from 'mobx';
import CrossCircleIcon from '@public/icon/game-room/cross_circle.svg';
import PauseCircleIcon from '@public/icon/game-room/pause_circle.svg';
import PlusIcon from '@public/icon/game-room/plus_thin.svg';
import ContinueIcon from '@public/icon/game-room/continue.svg';
import AddExtraBetIcon from '@public/icon/game-room/addExtraBet.svg';
import WithdrawExtraBetIcon from '@public/icon/game-room/withdrawExtraBet.svg';

import Icon, {
  CloseCircleOutlined,
  PlayCircleFilled,
  PauseCircleOutlined,
  HistoryOutlined,
  InteractionOutlined,
  DollarOutlined,
  Loading3QuartersOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import gameApi from '@utils/api/game.api';
import useRequest from '@utils/hooks/useRequestCustom';
import CopyIcon from '@public/images-mobile/game-room/copy-icon.svg';
import ShareIcon from '@public/images-mobile/game-room/share-icon.svg';
import SettingIcon from '@public/icon/game-room/setting.svg';
import MutedIcon from '@public/images-mobile/game-room/muted.svg';
import UnmutedIcon from '@public/images-mobile/game-room/unmuted.svg';
import HomeIcon from '@public/icon/game-room/home.svg';
import {v4 as uuidv4} from 'uuid';
import Tables from '@components/Tables';
import PingTimer from '@components/game-room/PingTimer';
import classNames from 'classnames';
import {JoinedRoomProps} from 'poker-interfaces/game-room/game-room-interface';
import {debounce, handleJoinRoom} from '@utils/index';
import {ResizeLoadingContextInterface, TabBubble as TabBubbleData} from '@interface/index';
import {ResizeLoadingContext} from '@utils/context';
import dayjs from 'dayjs';
import TabBubble from '@components/game-room/TabBubble';
import {useSwipeable} from 'react-swipeable';
import CustomPopup from '@components/CustomPopup';
import {useDisableDuplicateClick} from 'hooks/useDisabledDuplicatedClick';
import {CardObj} from 'poker-interfaces/gameLogic/gameLogicInterface';
import TabBubbleSectionInGame from './TabBubbleSectionInGame';
import {isTelegramMiniApp} from '..';

// TODO copy starts here
enum DropdownItems {
  LEAVE_GAME,
  LEAVE_SEAT,
  SIT_IN,
}

enum DropdownSettingItems {
  THEME_SETTING,
  ROOM_CODE_SHARE,
  ROOM_LINK_SHARE,
  TABLE_SETTING,
  UNIT_SETTING,
  EMOJI_MENU,
  WITHDRAW_EXTRA_BET,
  ADD_EXTRA_BET,
  HISTORY_DRAWER,
  AUDIO_SETTING,
  DEPOSIT,
}

// TODO: refactor
interface TablesInterface {
  roomNumbers: Array<string>;
  encryptionKeys: Array<string>;
  tablesOnCopy?: Function;
  tablesOnShare?: Function;
  tablesOnClickEmoji?: Function;
  tablesOnClickHistory?: Function;
  tablesOnClickWithdrawExtraBet?: Function;
  tablesOnClickAddExtraBet?: Function;
  quitTable?: (roomCode: string) => Promise<any>;
  sitOut?: (roomCode: string) => Promise<any>;
  sitIn?: (roomCode: string) => Promise<any>;
  sitOutPopUp?: (roomCode: string) => Promise<any>;
  setIsWithdrawChipsBtnShown?: (state: boolean, roomCode: string) => void;
  setIsDepositChipsBtnShown?: (state: boolean, roomCode: string) => void;
  setIsEmojiBtnShown?: Function;
  setIsSitOutNextHand?: (roomIndex: number, state: boolean) => void;
}

export const TABLE_MESSAGE_DURATION_MS = 3000;

type TableExitState = {
  roomCode: string;
  isExiting: boolean;
};

const MultipleGameRooms = React.forwardRef(
  (
    props: {
      tableExitStates: TableExitState[];
      setTableExitStates: (tableExitStates: TableExitState[]) => void;
      isLeavingVisible: boolean;
      setIsLeavingVisible: (isLeavingVisible: boolean) => void;
    },
    ref
  ) => {
    const {classes, session, system, socket, t, user, game, theme} = useCommon({
      withStyles: styles,
      withTranslation: ['game_room'],
      observers: ['session', 'system', 'socket', 'user', 'game'],
    });
    const router = useRouter();
    const [isMounted, setIsMounted] = useState(false);
    const [isSilentModeOn, setIsSilentModeOn] = useState<boolean>(false);
    const isDesktop = theme?.currentStyleFormat?.id === 'desktop';

    const {roomNumber: rmNoInQuery} = game;
    const {tableExitStates, isLeavingVisible, setTableExitStates, setIsLeavingVisible} = props;

    const isDebugView = useDebugView();
    const tablesDivRef = useRef<HTMLDivElement>();
    const tableComponentsRef = useRef<TablesInterface>(null);
    const [activeTableIndex, setActiveTableIndex] = useState<number>(0);
    const [isSitOutNextHand, setIsSitOutNextHand] = useState<boolean[]>([
      false,
      false,
      false,
      false,
    ]);
    // console.log('tableInActionIndicator', tableInActionIndicator);
    const [tablesScrollLeft, setTablesScrollLeft] = useState<number>(0);
    const [tablesInfo, setTablesInfo] = useState<Array<JoinedRoomProps>>([]);
    const [encryptionKeys, setEncryptionKeys] = useState<Array<string>>([null, null, null, null]);
    const roomCurrencyId = useCurrencyId() || '';
    const [isWithdrawChipsBtnShown, setIsWithdrawChipsBtnShown] = useState<boolean[]>([
      false,
      false,
      false,
      false,
    ]);
    const [isDepositChipsBtnShown, setIsDepositChipsBtnShown] = useState<boolean[]>([
      false,
      false,
      false,
      false,
    ]);
    const [isEmojiBtnShown, setIsEmojiBtnShown] = useState<boolean>(false);
    const [tablesTransitionStyle, setTablesTransitionStyle] = useState<string>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isDisconnected, setIsDisconnected] = useState<boolean>(false);
    const [isImagePreloading, setIsImagePreloading] = useState<boolean>(false);
    const [bubbleContent, setBubbleContent] = useState<TabBubbleData[]>([]);
    const [isGameOverlayShown, setIsGameOverlayShown] = useState<boolean>(false);
    const [socketClient, setSocketClient] = useState(null);
    const [isPageRefreshing, setIsPageRefreshing] = useState<boolean>(false);
    const [isLeavingReminderVisible, setIsLeavingReminderVisible] = useState<boolean>(false);
    const [observerStatus, setObserverStatus] = useState<boolean[]>([true, true, true, true]);

    const NEXT_PUBLIC_URL = env('NEXT_PUBLIC_URL');
    const NEXT_PUBLIC_RUNTIME_ENV = env('NEXT_PUBLIC_RUNTIME_ENV');

    useImperativeHandle(ref, () => ({
      quitTable: (roomCode: string) => {
        tableComponentsRef?.current?.quitTable(roomCode);
      },
    }));

    useEffect(() => {
      const checkPageRefresh = () => {
        console.log(' --- page refreshed --- ');
        const performanceEntries = performance.getEntriesByType('navigation');
        if (performanceEntries.length > 0) {
          const {type} = performanceEntries[0] as PerformanceNavigationTiming;
          if (type === 'reload') {
            setIsPageRefreshing(true);
            setTimeout(() => {
              setIsPageRefreshing(false);
            }, 2000);
          }
        }
      };

      checkPageRefresh();
    }, []);

    const roomTimeoutsRef = useRef({});

    // * if user has waited for 10 seconds to exit table, show a notification
    // * if user has successfully quit the room, clear the timeout
    useEffect(() => {
      const roomsExiting = tableExitStates.filter(room => room.isExiting);

      roomsExiting.forEach(room => {
        // if this room doesn't already have a timeout set, create one
        if (!roomTimeoutsRef.current[room.roomCode]) {
          roomTimeoutsRef.current[room.roomCode] = setTimeout(() => {
            notification.warning({
              message: t('ping_popup_title'),
              // description: room.roomCode,
            });

            // update the state to remove the room after the timeout
            setTableExitStates(prevStates =>
              prevStates.filter(prevRoom => prevRoom.roomCode !== room.roomCode)
            );

            // clear the timeout from the ref after execution
            delete roomTimeoutsRef.current[room.roomCode];
          }, 10000);
        }
      });

      return () => {
        Object.keys(roomTimeoutsRef.current).forEach(roomCode => {
          const roomStillExiting = tableExitStates.some(
            room => room.roomCode === roomCode && room.isExiting
          );

          if (roomStillExiting) {
            clearTimeout(roomTimeoutsRef.current[roomCode]);
            delete roomTimeoutsRef.current[roomCode];
          }
        });
      };
    }, [tableExitStates]);

    useEffect(() => {
      autorun(() => {
        if (
          user?.joinedRooms?.length > 0 &&
          JSON.stringify(tablesInfo) !== JSON.stringify(user.joinedRooms)
        ) {
          setTablesInfo(user.joinedRooms);
        }
        setActiveTableIndex(system?.activeTableIndex || 0);
        // setTablesTransitionStyle(system?.tablesTransition);

        if (socket?.client !== socketClient) {
          setSocketClient(socket.client);
        }
      });

      const handleLoading = () => {
        setIsLoading(true); // loading disabled in resize context
      };

      const debounceLoading = debounce(handleLoading, 0);
      // TODO may un-hide later
      // debounceLoading();
      window.addEventListener('resize', debounceLoading);
      return () => {
        window.removeEventListener('resize', debounceLoading);
      };
    }, []);

    useEffect(() => {
      if (socketClient) {
        socketClient.socket.on('connect', () => {
          setIsDisconnected(false);
        });

        setTimeout(() => {
          socketClient.socket.on('disconnect', reason => {
            console.log('reason', reason);
            setIsDisconnected(true);
          });
        }, 3000);
      }

      return () => {
        if (socketClient) {
          socketClient.socket.off('connect');
          socketClient.socket.off('disconnect');
        }
      };
    }, [socketClient]);

    //! may un-hide later
    // useEffect(() => {
    //   console.log('setRoomNumbers in Multi');
    //   setRoomNumbers(prevRoomNumbers =>
    //     prevRoomNumbers.map((rmNumber, index) => {
    //       if (index === 0) {
    //         return roomNumber;
    //       }
    //       return rmNumber;
    //     })
    //   );
    // }, [game.roomNumber]);

    useEffect(() => {
      setEncryptionKeys(prevKeys =>
        prevKeys.map((key, index) => {
          if (tablesInfo[index]?.roomCode !== null && !key) {
            return uuidv4();
          }
          return key;
        })
      );
    }, [tablesInfo]);

    const roomNumbers = tablesInfo.map(info => info?.roomCode || null);
    // console.log(' *** roomNumbers in Multi *** ', roomNumbers, tablesInfo);

    useEffect(() => {
      updateScrollPosition(activeTableIndex);

      const handleWindowResize = () => {
        updateScrollPosition(activeTableIndex);
      };

      const debounceResize = debounce(handleWindowResize, 100);

      debounceResize();
      window.addEventListener('resize', debounceResize);
      return () => window.removeEventListener('resize', debounceResize);
    }, [system, activeTableIndex]);

    const swipeHandlers = useSwipeable({
      onSwipedLeft: eventData => {
        if (eventData.deltaX < -120) {
          system.goNextTable(user.joinedRooms);
        }
      },
      onSwipedRight: eventData => {
        if (eventData.deltaX > 120) {
          system.goPrevTable(user.joinedRooms);
        }
      },
    });

    const resizeLoadingContextValue: ResizeLoadingContextInterface = useMemo(
      () => ({
        setIsResizeLoading: (state: boolean) => {
          setIsLoading(state);
        },
      }),
      []
    );

    const updateScrollPosition = (tableIndex: number) => {
      if (!tablesDivRef?.current) return;
      const MAX_TABLES = 4;
      setTablesScrollLeft(
        -(tablesDivRef.current.clientWidth / MAX_TABLES) * tableIndex - GAME_TABLE_MARGIN_PX
      );
    };

    const backToHome = (showRoomSetting: boolean = false): Promise<any> => {
      // hideDropdown();
      system.hideGameOverlay();

      if (isTelegramMiniApp) {
        return router.push('/telegram/game-list');
      } else {
        return router.push({
          pathname: '/home',
          query: {
            ...router.query,
            showRoomSetting,
          },
        });
      }
    };

    const handleMenuClick = useMemo(
      () => async (e, tableIndex: number) => {
        if (e.key === DropdownItems.LEAVE_GAME.toString()) {
          const isObserver = observerStatus[activeTableIndex];
          const currentTable = tablesInfo[activeTableIndex];
          const isTournament = currentTable?.roomType === 'TOURNAMENT';

          if (isObserver || isTournament) {
            console.log('Exiting table - isTournament:', isTournament, 'roomCode:', roomNumbers[activeTableIndex]);
            // For tournament tables or observers, quit immediately without confirmation
            tableComponentsRef.current.quitTable(roomNumbers[activeTableIndex]);
            setTableExitStates(prevStates => {
              const existingRoom = prevStates.find(
                room => room.roomCode === roomNumbers[activeTableIndex]
              );

              if (existingRoom) {
                return prevStates.map(room =>
                  room.roomCode === roomNumbers[activeTableIndex]
                    ? {...room, isExiting: true}
                    : room
                );
              }
              return [...prevStates, {roomCode: roomNumbers[activeTableIndex], isExiting: true}];
            });
            
            // If it's a tournament, redirect to tournament page after quit
            if (isTournament) {
              console.log('Tournament exit - hiding overlay and redirecting to /tournament');
              // Hide game overlay first to ensure navigation works
              system.hideGameOverlay();
              setTimeout(() => {
                console.log('Executing redirect to /tournament');
                router.push('/tournament').then(() => {
                  console.log('Redirect completed');
                }).catch(err => {
                  console.error('Redirect failed:', err);
                });
              }, 500); // Increased timeout to ensure exit is processed
            }
          } else {
            // For regular tables with seated players, show confirmation modal
            setIsLeavingVisible(true);
          }
        } else if (e.key === DropdownItems.LEAVE_SEAT.toString()) {
          await tableComponentsRef.current.sitOut(roomNumbers[tableIndex]);
        } else if (e.key === DropdownItems.SIT_IN.toString()) {
          await tableComponentsRef.current.sitIn(roomNumbers[tableIndex]);
        }
      },
      [activeTableIndex, roomNumbers, tablesInfo, router]
    );

    const handleThemeMenuClick = e => {
      user.currentTheme = e.key;
    };

    const themeMenu = (
      <Menu className={classes.leaveGameMenu} onClick={handleThemeMenuClick}>
        <Menu.Item className={classes.rectangularButton} key={COLOR_THEME.PURPLE}>
          purple
        </Menu.Item>
        <Menu.Item className={classes.rectangularButton} key={COLOR_THEME.GOLDEN}>
          golden
        </Menu.Item>
        <Menu.Item className={classes.rectangularButton} key={COLOR_THEME.GREEN}>
          green
        </Menu.Item>
      </Menu>
    );

    const {runAsync: getRandomRoomData} = useRequest(gameApi.getRandomRoom, {
      manual: true,
      onError: error => {
        console.log('getRandomRoom - error', error);
      },
    });

    const enterRoomRandomly = async () => {
      const currentRoomInfo = tablesInfo[activeTableIndex];
      const {gameType, currencyId, smallBlind, bigBlind, isAllIn} = currentRoomInfo || {};

      const randomRoomData = await getRandomRoomData({
        gameType,
        smallBlind,
        bigBlind,
        playerToken: user.getPlayerToken(),
        isAllIn,
        currencyId,
      });

      try {
        if (!randomRoomData) {
          throw new Error('Cannot find any available room');
        } else if (user.joinedRooms.find(room => room.roomCode === randomRoomData.roomCode)) {
          throw new Error('Cannot join the same room again');
        }
        await handleJoinRoom(
          user,
          system,
          socket,
          {
            isAllIn,
            roomCode: randomRoomData.roomCode,
          },
          t
        );
      } catch (e) {
        console.log('request random room failed', e);
      }
    };

    const setIsSitOutNextHandFunction = useCallback(
      (roomIndex: number, state: boolean) => {
        // if (Boolean(isSitOutNextHand?.[roomIndex]) !== state) {
        setIsSitOutNextHand(prev =>
          prev.map((item, index) => {
            if (index !== roomIndex) {
              return item;
            }
            return state;
          })
        );
      },
      [isSitOutNextHand]
    );

    const handleOnTabChange = (index: number): void => {
      if (!roomNumbers[index] || roomNumbers[index] === '') {
        // enterRoomRandomly(index);
      }
    };

    const copyRoomNumber = () => {
      console.log('tablesRef, activeTableIndex', tableComponentsRef, activeTableIndex);
      tableComponentsRef.current?.tablesOnCopy(roomNumbers[activeTableIndex]);
    };

    const shareLink = () => {
      tableComponentsRef.current?.tablesOnShare(roomNumbers[activeTableIndex]);
    };

    const onClickEmojiButton = () => {
      tableComponentsRef.current?.tablesOnClickEmoji(roomNumbers[activeTableIndex]);
    };

    const onClickHistoryButton = () => {
      tableComponentsRef.current?.tablesOnClickHistory(roomNumbers[activeTableIndex]);
    };

    const onClickWithdrawExtraBetButton = () => {
      // tableComponentsRef.current?.tablesOnClickWithdrawExtraBet(roomNumbers[activeTableIndex]);
    };

    const onClickAddExtraBetButton = () => {
      tableComponentsRef.current?.tablesOnClickAddExtraBet(roomNumbers[activeTableIndex]);
    };

    const onClickDepositButton = () => {
      system.showModalSheet('depositWithdraw');
    };

    const handleSettingMenuClick = e => {
      if (e.key === DropdownSettingItems.ROOM_CODE_SHARE.toString()) {
        copyRoomNumber();
      } else if (e.key === DropdownSettingItems.ROOM_LINK_SHARE.toString()) {
        shareLink();
      } else if (e.key === DropdownSettingItems.THEME_SETTING.toString()) {
        shareLink();
      } else if (e.key === DropdownSettingItems.TABLE_SETTING.toString()) {
        shareLink();
      } else if (e.key === DropdownSettingItems.UNIT_SETTING.toString()) {
        game?.changeUnit();
      } else if (e.key === DropdownSettingItems.AUDIO_SETTING.toString()) {
        toggleSilentMode();
      } else if (e.key === DropdownSettingItems.EMOJI_MENU.toString()) {
        onClickEmojiButton();
      } else if (e.key === DropdownSettingItems.HISTORY_DRAWER.toString()) {
        onClickHistoryButton();
      } else if (e.key === DropdownSettingItems.WITHDRAW_EXTRA_BET.toString()) {
        onClickWithdrawExtraBetButton();
      } else if (e.key === DropdownSettingItems.ADD_EXTRA_BET.toString()) {
        onClickAddExtraBetButton();
      } else if (e.key === DropdownSettingItems.DEPOSIT.toString()) {
        onClickDepositButton();
      }
    };

    const toggleSilentMode = useCallback((): void => {
      setIsSilentModeOn(!isSilentModeOn);
    }, [isSilentModeOn]);

    const handleAudioError = useCallback((): void => {
      // setIsSilentModeOn(true);
    }, []);

    const settingMenu = (
      <Menu className={classes.leaveGameMenu} onClick={handleSettingMenuClick}>
        <Menu.Item
          className={classes.leaveTableMenuItem}
          key={DropdownSettingItems.ROOM_CODE_SHARE.toString()}
          icon={<CopyIcon />}
        >
          {t('room_code_share')}
        </Menu.Item>
        <Menu.Item
          className={classes.leaveTableMenuItem}
          key={DropdownSettingItems.ROOM_LINK_SHARE.toString()}
          icon={<ShareIcon />}
        >
          {t('room_link_copy')}
        </Menu.Item>
        <Menu.Item
          className={classes.leaveTableMenuItem}
          key={DropdownSettingItems.HISTORY_DRAWER.toString()}
          icon={<HistoryOutlined />}
        >
          {t('history_drawer')}
        </Menu.Item>
        <Menu.Item
          className={classes.leaveTableMenuItem}
          key={DropdownSettingItems.UNIT_SETTING.toString()}
          icon={<InteractionOutlined />}
        >
          BB {t('unit_convert')}
        </Menu.Item>
        {!user?.isThirdPartyGateway() && (
          <Menu.Item
            className={classes.leaveTableMenuItem}
            key={DropdownSettingItems.DEPOSIT.toString()}
            icon={<DollarOutlined />}
          >
            {t('deposit')}
          </Menu.Item>
        )}
        {/* <Menu.Item
        className={classes.leaveTableMenuItem}
        key={DropdownSettingItems.AUDIO_SETTING.toString()}
        icon={
          isSilentModeOn ? (
            <MutedIcon className={classes.mutedIcon} />
          ) : (
            <UnmutedIcon className={classes.mutedIcon} />
          )
        }
      >
        {isSilentModeOn ? t('silent_mode_on') : t('silent_mode_off')}
      </Menu.Item> */}
      </Menu>
    );
    //! end

    /**
     * https://stackoverflow.com/questions/10240110/how-do-you-cache-an-image-in-javascript
     */
    const preloadImages = (srcArray: Array<string>) => {
      // const list: Array<any> = [];
      // for (let iii = 0; iii < srcArray.length; iii += 1) {
      //   const img = new Image();
      //   img.onload = function () {
      //     const index = list.indexOf(this);
      //     if (index !== -1) {
      //       // remove image from the array once it's loaded
      //       // for memory consumption reasons
      //       list.splice(index, 1);
      //       if (list.length === 1) {
      //         setIsImagePreloading(false);
      //       }
      //     }
      //   };
      //   list.push(img);
      //   img.src = srcArray[iii];
      // }
      const loadImage = (index: number) => {
        if (index >= srcArray.length) return; // Stop if all images are loaded
        const img = new Image();
        img.onload = function () {
          const imgIndex = list.indexOf(this);
          if (imgIndex !== -1) {
            list.splice(imgIndex, 1); // Remove image from the array
          }
          loadImage(index + 1); // Load the next image
        };
        img.src = srcArray[index];
        list.push(img); // Keep track of loaded images
      };
      const list: Array<any> = []; // Array to track loaded images
      loadImage(0);
    };

    // const {
    //   loading: getLoading,
    //   data: emojiList,
    //   runAsync: getEmojiList,
    // } = useRequest(diamondItemsApi.getStickers, {
    //   manual: true,
    //   onError: error => {
    //     console.log('getStickers - error', error);
    //   },
    // });

    // useEffect(() => {
    //   getEmojiList();
    // }, []);

    // useEffect(() => {
    //   const allImages: Array<string> = [];

    //   if (emojiList) {
    //     emojiList?.forEach(emoji => {
    //       allImages.push(`${NEXT_PUBLIC_URL}${emoji.image}`);
    //     });
    //     preloadImages(allImages);
    //   }
    // }, [emojiList]);

    const withdrawChipIconHandling = useCallback(
      (state: boolean, roomCode: string) => {
        const tableIndex = tablesInfo.findIndex(table => table.roomCode === roomCode);
        if (Boolean(isWithdrawChipsBtnShown?.[tableIndex]) !== state) {
          setIsWithdrawChipsBtnShown(oldData => {
            return oldData.map((original, index) => (index === tableIndex ? state : original));
          });
        }
      },
      [tablesInfo, isWithdrawChipsBtnShown]
    );

    const depositChipIconHandling = useCallback(
      (state: boolean, roomCode: string) => {
        const tableIndex = tablesInfo.findIndex(table => table.roomCode === roomCode);
        if (Boolean(isDepositChipsBtnShown?.[tableIndex]) !== state) {
          setIsDepositChipsBtnShown(oldData => {
            return oldData.map((original, index) => (index === tableIndex ? state : original));
          });
        }
      },
      [tablesInfo, isDepositChipsBtnShown]
    );

    // const hideDropdown = () => {
    //   setVisibleDropDownIndex(null);
    // };

    const handleAddRoom = async () => {
      // hideDropdown();
      if (tablesInfo[activeTableIndex]?.roomType === 'PRIVATE') {
        await backToHome(true);
        system.hideGameOverlay();
      } else if (tablesInfo[activeTableIndex]?.roomType === 'TOURNAMENT') {
        await router.push('/tournament');
        system.hideGameOverlay();
      } else {
        await enterRoomRandomly();
      }
    };

    const {wrappedFn: handleAddRoomWithThrottle, isLocking: isAddingRoom} =
      useDisableDuplicateClick(handleAddRoom, 2000);

    const spinIcon = (
      <Loading3QuartersOutlined spin style={{color: theme.textColor, fontSize: 25}} />
    );

    return (
      <Spin
        // spinning={(isLoading && isDesktop) || isImagePreloading || isPageRefreshing}
        // * overlap with fullScreenLoading in GameRoom
        spinning={false}
        indicator={spinIcon}
        wrapperClassName={classes.spinWrapper}
      >
        <div {...swipeHandlers} className={classes.multipleGameRoomsContainer}>
          <section className={classes.upperControlPanel}>
            <div className={classes.iconColumnContainer}>
              <Button
                className={classes.newSquareButton}
                onClick={() => {
                  backToHome();
                }}
              >
                <HomeIcon className={classes.iconInSquareButton} />
              </Button>
            </div>
            <div className={classes.centerPanel}>
              {/* otherwise dropdown menu will be displayed in homepage */}
              {system.isGameOverlayShown && (
                <TabBubbleSectionInGame
                  observerStatus={observerStatus}
                  handleMenuClick={handleMenuClick}
                  isQuittingTable={
                    tableExitStates.find(room => room.roomCode === roomNumbers[activeTableIndex])
                      ?.isExiting
                  }
                  isSitOutNextHand={isSitOutNextHand}
                  isConfirmLeavingPopUpVisible={isLeavingVisible}
                />
              )}
              {tablesInfo.length === 1 && (
                <>
                  {isSitOutNextHand[activeTableIndex] ? (
                    // * sit in button
                    <Button
                      className={classNames(classes.newSquareButton)}
                      onClick={async () => {
                        await tableComponentsRef.current.sitIn(roomNumbers[activeTableIndex]);
                      }}
                    >
                      <ContinueIcon className={classes.iconInSquareButton} />
                    </Button>
                  ) : (
                    !observerStatus[activeTableIndex] && (
                      // * sit out button
                      <Button
                        className={classNames(classes.newSquareButton)}
                        onClick={async () => {
                          await tableComponentsRef.current.sitOut(roomNumbers[activeTableIndex]);
                        }}
                      >
                        <PauseCircleIcon className={classes.iconInSquareButton} />
                      </Button>
                    )
                  )}
                  {/* leave game button  */}
                  <Button
                    className={classNames(classes.newSquareButton)}
                    onClick={() => {
                      const isObserver = observerStatus[activeTableIndex];
                      const currentTable = tablesInfo[activeTableIndex];
                      const isTournament = currentTable?.roomType === 'TOURNAMENT';

                      if (isObserver || isTournament) {
                        // For tournament tables or observers, quit immediately without confirmation
                        tableComponentsRef.current.quitTable(roomNumbers[activeTableIndex]);
                        setTableExitStates(prevStates => {
                          const existingRoom = prevStates.find(
                            room => room.roomCode === roomNumbers[activeTableIndex]
                          );

                          if (existingRoom) {
                            return prevStates.map(room =>
                              room.roomCode === roomNumbers[activeTableIndex]
                                ? {...room, isExiting: true}
                                : room
                            );
                          }
                          return [
                            ...prevStates,
                            {roomCode: roomNumbers[activeTableIndex], isExiting: true},
                          ];
                        });
                        
                        // If it's a tournament, redirect to tournament page after quit
                        if (isTournament) {
                          // Hide game overlay first to ensure navigation works
                          system.hideGameOverlay();
                          setTimeout(() => {
                            router.push('/tournament');
                          }, 100);
                        }
                      } else {
                        // For regular tables with seated players, show confirmation modal
                        setIsLeavingVisible(true);
                      }
                    }}
                  >
                    {tableExitStates.find(room => room.roomCode === roomNumbers[activeTableIndex])
                      ?.isExiting ? (
                      <Loading3QuartersOutlined spin className={classes.iconInSquareButton} />
                    ) : (
                      <CrossCircleIcon className={classes.iconInSquareButton} />
                    )}
                  </Button>
                </>
              )}
              {tablesInfo.length < 4 && (
                <Button
                  loading={isAddingRoom}
                  className={classNames(classes.plusButton)}
                  onClick={handleAddRoomWithThrottle}
                  // onMouseEnter={hideDropdown}
                >
                  {!isAddingRoom && <PlusIcon className={classes.plusIcon} />}
                </Button>
              )}
            </div>
            <div className={classes.iconRowContainer}>
              <Button
                className={classes.newSquareButton}
                onClick={() => {
                  toggleSilentMode();
                }}
              >
                {isSilentModeOn ? (
                  <MutedIcon className={classes.mutedIcon} />
                ) : (
                  <UnmutedIcon className={classes.mutedIcon} />
                )}
              </Button>
              {isDepositChipsBtnShown[activeTableIndex] && tablesInfo[activeTableIndex]?.roomType !== 'TOURNAMENT' && (
                <Tooltip placement="bottomRight" color="#33333c" title={t('add_extra_bet')}>
                  <Button
                    className={classes.newSquareButton}
                    onClick={() => {
                      onClickAddExtraBetButton();
                    }}
                  >
                    <AddExtraBetIcon className={classes.iconInSquareButton} />
                  </Button>
                </Tooltip>
              )}
              {/* {isWithdrawChipsBtnShown[activeTableIndex] && (
              <Tooltip placement="bottomRight" color="#33333c" title={t('withdraw_extra_bet')}>
                <Button
                  className={classes.newSquareButton}
                  onClick={() => {
                    onClickWithdrawExtraBetButton();
                  }}
                >
                  <WithdrawExtraBetIcon className={classes.iconInSquareButton} />
                </Button>
              </Tooltip>
            )} */}
              <Dropdown overlay={settingMenu} placement="bottomRight" trigger={['click']}>
                <Button className={classes.newSquareButton}>
                  <SettingIcon className={classes.iconInSquareButton} />
                </Button>
              </Dropdown>
            </div>
            {isDebugView ? (
              <Dropdown placement="bottomLeft" overlay={themeMenu} trigger={['click']}>
                <Button
                  style={{position: 'absolute', top: '40px', left: '40px'}}
                  className={classes.rectangularButton}
                >
                  {t('common:theme')}
                </Button>
              </Dropdown>
            ) : null}
          </section>
          <section
            style={{left: tablesScrollLeft, transition: tablesTransitionStyle}}
            ref={tablesDivRef}
            className={classes.tablesContainer}
          >
            <Tables
              ref={tableComponentsRef}
              tablesInfo={tablesInfo}
              encryptionKeys={encryptionKeys}
              setIsWithdrawChipsBtnShown={withdrawChipIconHandling}
              setIsDepositChipsBtnShown={depositChipIconHandling}
              setIsEmojiBtnShown={setIsEmojiBtnShown}
              setIsSitOutNextHand={setIsSitOutNextHandFunction}
              areTablesMuted={isSilentModeOn}
              onAudioError={handleAudioError}
              setObserverStatus={setObserverStatus}
            />
          </section>
          <CustomPopup
            title={t('disconnected_modal_title')}
            width={300}
            open={isDisconnected && isGameOverlayShown}
            closable={false}
            centered={false}
          >
            <span className={classes.modalTitle}>{t('ping_popup_content')}</span>
          </CustomPopup>
        </div>
      </Spin>
    );
  }
);
MultipleGameRooms.displayName = 'MultipleGameRooms';

export default MultipleGameRooms;
